// searchbar.js

export function initializeSearchbar() {
  const searchBar = $(".searchbar");
  const searchInput = $(".searchbar__input");
  const searchForm = $(".searchbar__form");
  const searchResults = $(".searchbar__results");
  const searchLink = $(".nav__item-top-search .nav__link-top");
  const searchLinkMobile = $(".navbar__search-mobile");
  const searchButtonClose = $(".searchbar__close");
  const searchEnter = $(".searchbar__enter");
  const searchLoader = $(".searchbar__loader");

  searchLink.click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    searchForm.add("body").addClass("searchbar-opened");
    searchInput.focus();
  });

  searchLinkMobile.click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    searchForm.add("body").addClass("searchbar-opened");
    searchInput.focus();
  });

  searchEnter.click(function (e) {
    e.preventDefault();
    searchAjax(searchInput.val());
  });

  searchButtonClose.click(function () {
    closeSearchbar();
  });

  function closeSearchbar() {
    searchResults.removeClass("searchbar-opened");

    let timeout = 0;

    if (searchForm.hasClass("searchbar-opened")) {
      timeout = 200;
    }

    setTimeout(function () {
      searchForm.add("body").removeClass("searchbar-opened");
      searchInput.val("");
    }, timeout);
  }

  function searchAjax(filter) {
    if (filter) {
      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        data: { action: "custom_search", filter: filter },
        type: "POST",
        beforeSend: function () {
          searchEnter.addClass("d-none");
          searchLoader.removeClass("d-none");
        },
        success: function (data) {
          searchEnter.removeClass("d-none");
          searchLoader.addClass("d-none");
          searchResults.addClass("searchbar-opened").html(data);
        },
      });
    }

    return false;
  }

  $(document).on("click", function (e) {
    if (
      !searchBar.is(e.target) &&
      searchBar.has(e.target).length === 0 &&
      !searchLink.is(e.target)
    ) {
      closeSearchbar();
    }
  });

  $(document).on("keydown", function (e) {
    if (e.which === 27) {
      if (searchForm.hasClass("searchbar-opened")) {
        closeSearchbar();
      }
    }

    if (e.which === 13) {
      if (searchForm.hasClass("searchbar-opened")) {
        searchAjax(searchInput.val());
      }
    }
  });
}
